/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React from "react";
import { useSelector } from "react-redux";
import DesktopRoom from "./DesktopRoom/DesktopRoom";
import VRRoom from "./VRRoom/VRRoom";

const HomeRoom = () => {
    const inVRMode = useSelector((state) => state.private.device.inVRMode);

    if (inVRMode) return <VRRoom />;
    else return <DesktopRoom />;
};

export default HomeRoom;